import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import api from "../../utils/axios";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";

import { showLoader, hideLoader, showAlert, isEmpty, showContaimerLoader, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "documenttype";
const modulePath = "/documenttype";
const moduleName = "Document Type";
const moduleID = 11;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        documentType: "",
        hideExpiryDate: false,
        mandatoryDocument: false,
        vesseleMandatory: [],
        rankMandatory: [],
      },
      detaildata: [],
      rankList: [],
      vessleTypeList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;
          const vesseleMandatory = result.vesseleMandatory ?? "";
          const vesseleMandatory_ =
            vesseleMandatory !== "" && vesseleMandatory !== null
              ? vesseleMandatory
                  .split(",")
                  .map((item) => item.trim())
                  .filter((item) => item !== "")
                  .map((item) => ({ label: item, value: item }))
              : "";

          const rankMandatory = result.rankMandatory ?? "";
          const rankMandatory_ =
            rankMandatory !== "" && rankMandatory !== null
              ? rankMandatory
                  .split(",")
                  .map((item) => item.trim())
                  .filter((item) => item !== "")
                  .map((item) => ({ label: item, value: item }))
              : "";

          const clientupdatedata = {
            documentType: result.documentType,
            hideExpiryDate: result.hideExpiryDate,
            mandatoryDocument: result.mandatoryDocument === "Y" ? true : false,
            vesseleMandatory: vesseleMandatory_,
            rankMandatory: rankMandatory_,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadDropdown() {
    api
      .get("rank/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ rankList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vesseltype/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ vessleTypeList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;
    let vesseleMandatory = postData.vesseleMandatory.length > 0 ? postData.vesseleMandatory.map((item) => item.value) : "";
    let rankMandatory = postData.rankMandatory.length > 0 ? postData.rankMandatory.map((item) => item.value) : "";
    const postObject = {
      documentType: postData.documentType.toUpperCase(),
      hideExpiryDate: postData.hideExpiryDate === true ? 1 : 0,
      mandatoryDocument: postData.mandatoryDocument === true ? "Y" : "",
      vesseleMandatory: postData.mandatoryDocument === false ? (vesseleMandatory !== "" ? vesseleMandatory.join(",") : "") : "",
      rankMandatory: postData.mandatoryDocument === false ? (rankMandatory !== "" ? rankMandatory.join(",") : "") : "",
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            rankList={this.state.rankList}
                            vessleTypeList={this.state.vessleTypeList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { documentType } = props.fields;

  return {
    fields: ["documentType"],
    validations: {
      documentType: [[isEmpty, documentType]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slectedPDF: "",
    };
  }
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handlecheckedChange(name, e) {
    this.props.onChange(name, e.target.checked);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgdocumentType = "";
    if ($validation.documentType.error.reason !== undefined) {
      errMsgdocumentType = $validation.documentType.show && <span className="error">{$validation.documentType.error.reason}</span>;
    }

    return (
      <div>
        <button class="btn btn-secondary bg-secondary-gradient mt-3" data-bs-toggle="modal" data-bs-target="#extralargemodal" id="viewPerticular" style={{ display: "none" }}>
          Extralarge Modal
        </button>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Document Type<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Document Type"
                name="documentType"
                value={fields.documentType}
                {...$field("documentType", (e) => onChange("documentType", e.target.value))}
              />
              {errMsgdocumentType}
            </div>
            <div className="form-group col-md-2">
              <div class="custom-controls-stacked mt-6 mx-5">
                <label class="custom-control custom-checkbox-md">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    name="example-checkbox5"
                    value="option5"
                    checked={fields.hideExpiryDate}
                    onChange={this.handlecheckedChange.bind(this, "hideExpiryDate")}
                  />
                  <span class="custom-control-label">Ignore Expiry</span>
                </label>
              </div>
            </div>
            <div className="form-group col-md-2">
              <div class="custom-controls-stacked mt-6 mx-5">
                <label class="custom-control custom-checkbox-md">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    name="example-checkbox5"
                    value="option5"
                    checked={fields.mandatoryDocument}
                    onChange={this.handlecheckedChange.bind(this, "mandatoryDocument")}
                  />
                  <span class="custom-control-label">Mandatory</span>
                </label>
              </div>
            </div>
            {fields.mandatoryDocument === false && (
              <>
                <div className="form-group col-md-6">
                  <label className="form-label">Mandatory Vessel Type</label>
                  <Select
                    value={fields.vesseleMandatory}
                    onChange={this.handleSelectChange.bind(this, "vesseleMandatory")}
                    placeholder="Select Vessel Type"
                    isClearable={true}
                    isMulti={true}
                    options={this.props.vessleTypeList}
                  />
                </div>

                <div className="form-group col-md-6">
                  <label className="form-label">Mandatory Rank</label>
                  <Select
                    value={fields.rankMandatory}
                    onChange={this.handleSelectChange.bind(this, "rankMandatory")}
                    placeholder="Select Vessel Type"
                    isClearable={true}
                    isMulti={true}
                    options={this.props.rankList}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
